import React, { useState, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';

export const PaymentCancel = () => {
  const [redirect, setRedirect] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paymentId = searchParams.get('checkout-reference');
  const dashboardUrl = {
    pathname: '/user-dashboard',
    search: paymentId
      ? `?paymentError=cancel&paymentId=${encodeURIComponent(paymentId)}`
      : '?paymentError=cancel',
  };

  useEffect(() => {
    let timer1 = setTimeout(() => setRedirect(true), 3000);

    // this will clear Timeout when component unmount like in willComponentUnmount
    return () => {
      clearTimeout(timer1);
    };
  }, []);

  return redirect ? (
    <Redirect to={dashboardUrl}></Redirect>
  ) : (
    <Typography>Maksu peruttiin. Palaat maksutavan valintaan.</Typography>
  );
};

export default PaymentCancel;
